"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNpsCategory = exports.calculateNpsScore = exports.getSurveyReOpenedText = exports.getSurveyEditText = exports.isAgreeDisagreeQuestion = exports.surveyResponseSort = exports.questionResponseSort = exports.getQuestionResponses = exports.getAllResponseComments = void 0;
function getAllResponseComments(responses) {
    return responses.reduce((comments, response) => {
        if (response.comments) {
            response.comments.forEach(comment => {
                comments.push(Object.assign(Object.assign({}, comment), { user: response.user }));
            });
        }
        return comments;
    }, []);
}
exports.getAllResponseComments = getAllResponseComments;
const getQuestionResponses = (surveyResponses, questionId) => {
    return surveyResponses.reduce((responses, response) => {
        const qr = response.responses.find(q => q.questionId === questionId);
        if (qr) {
            responses.push({
                response: qr,
                user: response.user,
            });
        }
        return responses;
    }, []);
};
exports.getQuestionResponses = getQuestionResponses;
const questionResponseSort = (a, b) => {
    var _a, _b;
    const aDate = (_a = a.response.updatedAt) !== null && _a !== void 0 ? _a : a.response.createdAt;
    const bDate = (_b = b.response.updatedAt) !== null && _b !== void 0 ? _b : b.response.createdAt;
    return bDate.getTime() - aDate.getTime();
};
exports.questionResponseSort = questionResponseSort;
const surveyResponseSort = (a, b) => {
    var _a, _b;
    const aDate = (_a = a.updatedAt) !== null && _a !== void 0 ? _a : a.createdAt;
    const bDate = (_b = b.updatedAt) !== null && _b !== void 0 ? _b : b.createdAt;
    return bDate.getTime() - aDate.getTime();
};
exports.surveyResponseSort = surveyResponseSort;
const isAgreeDisagreeQuestion = (question) => {
    return question.templateId === "qte:3a7b2a39-ee16-4672-b279-81f62c661c6f";
};
exports.isAgreeDisagreeQuestion = isAgreeDisagreeQuestion;
const getSurveyEditText = (votesInvalidated) => {
    return `ⓘ Polly updated${votesInvalidated ? " - Please respond to the changes" : ""}`;
};
exports.getSurveyEditText = getSurveyEditText;
const getSurveyReOpenedText = () => {
    return "ⓘ Polly reopened";
};
exports.getSurveyReOpenedText = getSurveyReOpenedText;
const calculateNpsScore = (choices, userResponses) => {
    const detractors = [];
    const passives = [];
    const promoters = [];
    const choiceMap = choices.reduce((map, choice) => {
        map[choice.id] = choice.value;
        return map;
    }, {});
    for (const userResponse of userResponses) {
        const responseValue = userResponse.response.value;
        const category = (0, exports.getNpsCategory)(choiceMap[responseValue]);
        const isDetractor = category === "detractor";
        const isPassive = category === "passive";
        const isPromoter = category === "promoter";
        if (isDetractor) {
            detractors.push(userResponse.user.name);
        }
        if (isPassive) {
            passives.push(userResponse.user.name);
        }
        if (isPromoter) {
            promoters.push(userResponse.user.name);
        }
    }
    const totalVotes = detractors.length + passives.length + promoters.length;
    const detractorPercentage = totalVotes === 0 ? 0 : (detractors.length / totalVotes) * 100;
    const promoterPercentage = totalVotes === 0 ? 0 : (promoters.length / totalVotes) * 100;
    const passivePercentage = totalVotes === 0 ? 0 : (passives.length / totalVotes) * 100;
    const nps = Math.round(promoterPercentage - detractorPercentage);
    const npsScore = {
        totalVotes,
        nps,
        detractors,
        passives,
        promoters,
        detractorPercentage,
        passivePercentage,
        promoterPercentage,
    };
    return npsScore;
};
exports.calculateNpsScore = calculateNpsScore;
const getNpsCategory = (value) => {
    if (value <= 6) {
        return "detractor";
    }
    else if (value <= 8) {
        return "passive";
    }
    else {
        return "promoter";
    }
};
exports.getNpsCategory = getNpsCategory;
//# sourceMappingURL=surveyHelpers.js.map